var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.820156 2.8834C0.820156 3.17046 1.05285 3.40315 1.3399 3.40315H1.8979L2.64078 13.1101C2.66152 13.381 2.88735 13.5902 3.15902 13.5902H9.70783C9.9795 13.5902 10.2053 13.381 10.2261 13.1101L10.9689 3.40315H11.5269C11.814 3.40315 12.0467 3.17046 12.0467 2.8834C12.0467 2.59635 11.814 2.36366 11.5269 2.36366H8.98018V1.81792C8.98018 0.972475 8.29238 0.284668 7.44693 0.284668H5.41992C4.57447 0.284668 3.88666 0.972475 3.88666 1.81792V2.36366H1.3399C1.05285 2.36366 0.820156 2.59635 0.820156 2.8834ZM7.94069 2.36366H4.92616V1.81792C4.92616 1.54565 5.14765 1.32416 5.41992 1.32416H7.44693C7.7192 1.32416 7.94069 1.54565 7.94069 1.81792V2.36366ZM2.94044 3.40315H9.92641L9.22634 12.5507H3.64051L2.94044 3.40315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/delete-white.36f2a669abab916c3058a73f405e4771.svg";
export { ForwardRef as ReactComponent };